const SITE_URL = 'https://moneymonkapp.in';
const LOGO_URL = `${SITE_URL}/img/logo.png`;

function stripHtml(html) {
    return (html || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

export function organizationSchema() {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'MoneyMonk',
        url: SITE_URL,
        logo: {
            '@type': 'ImageObject',
            url: LOGO_URL
        },
        description: 'MoneyMonk is a digital lending platform owned and operated by Monk Capital Private Limited, an RBI Registered Non-Banking Financial Company (NBFC), Regn No. N-09.00457.',
        sameAs: [
            'https://www.facebook.com/people/Money-Monk/61582583677750/',
            'https://www.instagram.com/moneymonkapp/',
            'https://www.linkedin.com/company/moneymonk-app/'
        ]
    };
}

export function websiteSchema() {
    return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'MoneyMonk',
        url: SITE_URL
    };
}

export function breadcrumbSchema(items) {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.url
        }))
    };
}

export function blogPostingSchema(post) {
    const url = `${SITE_URL}/blog/${post.slug}`;
    const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
    const authorName = post._embedded?.author?.[0]?.name || 'MoneyMonk';

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: stripHtml(post.title.rendered),
        description: stripHtml(post.excerpt?.rendered || '').substring(0, 160),
        articleBody: stripHtml(post.content?.rendered || ''),
        url,
        datePublished: post.date,
        dateModified: post.modified || post.date,
        author: {
            '@type': 'Person',
            name: authorName
        },
        publisher: {
            '@type': 'Organization',
            name: 'MoneyMonk',
            logo: {
                '@type': 'ImageObject',
                url: LOGO_URL
            }
        },
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': url
        }
    };

    if (featuredImage) {
        schema.image = featuredImage;
    }

    return schema;
}
